import { render, staticRenderFns } from "./index-bak.vue?vue&type=template&id=46132806&scoped=true&"
import script from "./index-bak.vue?vue&type=script&lang=js&"
export * from "./index-bak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46132806",
  null
  
)

export default component.exports